import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { CampaignService } from "../services/Campaign.service";
import {
  BRIEF_CAMPAIGNS_LIST_QUERY_KEY,
  VENDOR_BILLING_QUERY_KEY,
} from "../contsants";

export function useAttachVendorBilling(briefId: string, influencerId: string) {
  const {
    mutate: attachVendorBilling,
    isLoading: isAttaching,
    isSuccess: isAttached,
  } = useMutation<{
    campaignInfluencerId: string;
    vendorBillingId: string;
    isEdit: boolean;
  }>({
    mutationFn: async ({ campaignInfluencerId, vendorBillingId, isEdit }) => {
      return await CampaignService.attachVendorBilling(
        campaignInfluencerId,
        vendorBillingId,
        isEdit
      ).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      });
    },
    onSuccess: (c, _) => {
      c.invalidateQueries({
        queryKey: [...VENDOR_BILLING_QUERY_KEY(influencerId || "")],
      });
      c.invalidateQueries({
        queryKey: [...BRIEF_CAMPAIGNS_LIST_QUERY_KEY(briefId)],
      });
    },
    options: {},
  });

  return {
    attachVendorBilling,
    isAttaching,
    isAttached,
  };
}
